import styled from 'styled-components';
import React, { FC } from 'react';

const Wrapper = styled.div`
  text-align: center;
`;

const Container = styled.span`
  border: 1px solid #d8d8d8;
  padding: 8px 0;
`;

const Button = styled.button`
  padding: 8px 16px;
  background-color: transparent;
  border: 0;
`;

const ValueView = styled.input`
  width: 40%;
  text-align: center;
  border: 0;
  -moz-appearance: textfield;
  cursor: default;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[disabled] {
    background-color: inherit;
  }
`;

type Props = {
  min?: number;
  max?: number;
  value?: number;
  onChange?: (value: number) => void;
};

export const SpinButton: FC<Props> = ({ min, max, value, onChange }) => {
  const onClickPlus = () => {
    let v = value ? value! : 0;
    if ((!max || max >= v + 1) && onChange) {
      onChange(v + 1);
    }
  };

  const onClickMinus = () => {
    let v = value ? value! : 0;
    if ((!min || min <= v - 1) && onChange) {
      onChange(v - 1);
    }
  };

  return (
    <Wrapper>
      <Container>
        <Button onClick={onClickMinus}>−</Button>
        <ValueView type={'number'} min={min} max={max} value={value} readOnly={true} disabled={true} />
        <Button onClick={onClickPlus}>＋</Button>
      </Container>
    </Wrapper>
  );
};
